import { UserProvider } from "auth";
import { Theme, theme } from "./melodies-source/Theme";
import { Routes } from "Routes";
import { Toast } from "melodies-source/Toast";
import { ContactProvider } from "Components";

const t = {
  ...theme,
  media: {
    mobile: "@media all and (max-width: 767px)",
    tablet: "@media all and (min-width: 768px)",
    maxTablet: "@media all and (max-width: 1279px)",
    desktop: "@media all and (min-width: 1280px)",
  },
};

function App() {
  return (
    <UserProvider>
      <Theme theme={t}>
        <ContactProvider>
          <Routes />
          <Toast />
        </ContactProvider>
      </Theme>
    </UserProvider>
  );
}

export default App;
